import createCrudModule from '@modules/crud/createCrudModule'


// Models
import UserModel from './models/user.model'
import AdminModel from './models/admin.model'
import CandidateModel from './models/candidate.model'
import ClientModel from './models/client.model'

export { UserModel, AdminModel, CandidateModel, ClientModel }

const userModules =  {
	admin: createCrudModule('admin', AdminModel.getDefaults()),
	client: createCrudModule('client', ClientModel.getDefaults()),
	candidate: createCrudModule('candidate', CandidateModel.getDefaults()),
}

export default userModules;



// WEBPACK FOOTER //
// ./src/modules/user/user.module.js